var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomMenuIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C17.5 5.85938 14.1406 2.5 10 2.5C5.85938 2.5 2.5 5.85938 2.5 10C2.5 14.1406 5.85938 17.5 10 17.5C14.1406 17.5 17.5 14.1406 17.5 10Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45001 13.064L12.9207 10.3632C12.983 10.3252 13.0345 10.2719 13.0703 10.2082C13.106 10.1446 13.1248 10.0729 13.1248 9.99991C13.1248 9.92693 13.106 9.85519 13.0703 9.79157C13.0345 9.72795 12.983 9.67459 12.9207 9.63662L8.45001 6.93584C8.38593 6.89745 8.31278 6.8768 8.23809 6.876C8.16339 6.8752 8.08982 6.89429 8.02494 6.93131C7.96005 6.96832 7.90618 7.02193 7.86885 7.08664C7.83152 7.15134 7.81207 7.22481 7.81251 7.29951V12.7003C7.81207 12.775 7.83152 12.8485 7.86885 12.9132C7.90618 12.9779 7.96005 13.0315 8.02494 13.0685C8.08982 13.1055 8.16339 13.1246 8.23809 13.1238C8.31278 13.123 8.38593 13.1024 8.45001 13.064Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomMenuIcon1);
export default __webpack_public_path__ + "static/media/bottom-menu-icon1.bb652fd2221e7d500e0a4a20401076f6.svg";
export { ForwardRef as ReactComponent };